/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { comboProductSchema } from "./comboProductSchema.ts";
import { localizationStrSchema } from "./localizationStrSchema.ts";

export const comboGroupSuggestionSchema = z.object({
	id: z.uuid(),
	name: z.string(),
	image_link: z.string().nullable(),
	video_link: z.string().nullable(),
	loc_name: localizationStrSchema.describe("Util serializer for representation in swagger"),
	products: z.array(comboProductSchema),
	required: z.boolean(),
	is_main: z.boolean(),
});
